import { ActionReducer, MetaReducer } from '@ngrx/store';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { AppState } from '../app.state';
import * as fromAuthReducer from './auth.reducer';
import * as fromAccountReducer from './account.reducer';
import * as fromSharedReducer from './shared.reducer';
import { environment } from 'src/environments/environment';


export const reducers = {
  auth: fromAuthReducer.reducer,
  router: routerReducer as any as ActionReducer<RouterReducerState<any>>,
  account: fromAccountReducer.reducer,
  shared: fromSharedReducer.reducer,
};

export const metaReducers: MetaReducer<AppState>[] = !environment.production
  ? []
  : [];
